import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';

const VectorGrid = ({id, url, layerName, color, opacity, borderColor}) => {
    const map = useMap()
    const { state, dispatch } = useContext(Context);

    let styleOptions = null;
    
    if (["vis_90_7","vis_90_8","vis_90_10","vis_90_12","vis_90_13","vis_90_14"].includes(id)) {
        // 県全域は塗りつぶしは無し、線のみ太く。
        styleOptions = {
            color: "#06ACFF",// 線
            weight: 7,
            opacity: state.opacity,
            fill: true,
            fillColor: color,
            fillOpacity: 0
        }
        
    } else if (["vis_90_9_1","vis_90_11_1"].includes(id)) {
        // 県の太い枠線に指定した色をつける場合はこちら。
        // 河川法、文化財保護法
        styleOptions = {
            color: borderColor,// 線
            weight: 7,
            opacity: state.opacity,
            fill: true,
            fillColor: color,
            fillOpacity: 0
        }

    } else if (["vis_90_9_2","vis_90_9_3"].includes(id)) {
        // 河川の中心の表示
        styleOptions = {
            color: borderColor,// 線
            weight: 3,
            opacity: state.opacity,
            fill: true,
            fillColor: color,
            fillOpacity: 1
        }

    } else {
        styleOptions = {
          color: color,// 線
          weight: 0, // 線を消す
          opacity: state.opacity,
          fill: true,
          fillColor: color,
          fillOpacity: state.opacity
        }
    }
    
    useEffect(() => {
        
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive: true,
            vectorTileLayerStyles: {
                [layerName]: function(properties, i){
                    return styleOptions
                }
            },
        })

        vectorGrid.on('click', function(e) {
            if(!e.originalEvent.isTrusted){
                dispatch({
                    type: 'TOGGLE_CHECKED',
                    category: id
                })
    
                dispatch({
                    type: 'SET_VLAYER_INFO',
                    id: id,
                    properties: e.layer.properties
                })
            }
        });
        
        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])

    return null
}

export default VectorGrid
